import { CalendarEvent } from '@/types/calendar';

import CalendarEventEditModal from '@/components/calendar/CalendarEventEditModal';

interface CommunityCalendarEventEditModalProps {
  event: CalendarEvent;
  onClose: () => void;
  onEventDeleted?: () => void;
  onEventUpdated?: () => void;
}

const CommunityCalendarEventEditModal = ({
  event,
  onClose,
  onEventDeleted,
  onEventUpdated,
}: CommunityCalendarEventEditModalProps) => 
  // For now, we'll reuse the existing CalendarEventEditModal
  // In the future, we can customize this specifically for community events
  <CalendarEventEditModal
    event={event}
    onClose={onClose}
    onEventDeleted={onEventDeleted}
    onEventUpdated={onEventUpdated}
  />;

export default CommunityCalendarEventEditModal;